import * as Modules from './registries';

function registriesModules(): void {
  for (const register of Object.values(Modules)) {
    register();
  }
}
export { registriesModules };
